<template>
    <h3>loading...</h3>
</template>
<script>
export default {
  name: "load-index",
  data() {
    return {};
  },
  mounted(){
      this.isLogin();
  },
  methods: {
    isLogin() {
      let token = localStorage.getItem("loginToken");
      if (token !== null && token !== undefined) {
        this.$router.push("/home");
      }else{
          this.$router.push("/login");
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/LoadIndex.vue